/**
 * Common props, methods etc for day vue in yearly and monthly calendar
 */

import { mapGetters, mapMutations, mapActions } from "vuex";

export const dayMixin = {
  props: {
    date: String // A full formatted date is expected as prop
  },
  computed: {
    ...mapGetters({
      appointmentDates: "getAppointmentDates",
      selectedProviderID: "getSelectedProviderID"
    }),
    dayOfMonth() {
      return parseInt(this.date.split("-")[2]);
    },
    month() {
      return parseInt(this.date.split("-")[1]);
    },
    year() {
      return parseInt(this.date.split("-")[0]);
    },
    currentDay() {
      let today = new Date();
      return (
        today.getDate() === this.dayOfMonth &&
        today.getMonth() + 1 === this.month &&
        today.getFullYear() === this.year
      );
    }
  },
  methods: {
    ...mapMutations({
      setDayOfMonth: "setDayOfMonth",
      setMonth: "setMonth",
      setYear: "setYear",
      setWeek: "setWeek"
    }),
    ...mapActions({
      getAppointmentDetails: "getAppointmentDetails"
    }),
    /**
     * What to do when someone has clicked on a particualr date on the calendar
     */
    goToDaily() {
      this.setDayOfMonth(this.dayOfMonth);
      this.setWeek(this.dayOfMonth);
      this.setMonth(this.month - 1);
      this.setYear(this.year);
      if (
        this.fetchAppointmentDetails !== undefined &&
        this.fetchAppointmentDetails !== false
      ) {
        this.getAppointmentDetails();
      } else {
        this.$router.push("/daily");
      }
    }
  }
};
